<img [src]="imageUrl" />
<form [formGroup]="form" (ngSubmit)="onSave()">
  <app-text-field
    ngDefaultControl
    formControlName="url"
    label="Image url"
    [value]="imageUrl"
    [errorMessage]="getImageUrlErrorMessage()"
  ></app-text-field>
  <app-text-field ngDefaultControl formControlName="title" label="Title" [value]="title"></app-text-field>
  <app-select
    label="Category"
    [value]="formControls.category.value"
    [options]="getCategoryOptions()"
    color="secondary"
    (optionSelected)="onOptionSelect(formControls.category, $event, formControls.subcategory)"
  ></app-select>
  <app-select
    label="Subcategory"
    [value]="formControls.subcategory.value"
    [options]="getSubcategoryOptions()"
    color="secondary"
    (optionSelected)="onOptionSelect(formControls.subcategory, $event)"
  ></app-select>
  <app-button size="lg" type="submit">Save</app-button>
</form>
